import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useRef, useState } from "react"
// import { Editor } from "react-draft-wysiwyg"
import { Editor } from "@tinymce/tinymce-react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap"
import ToastDialog from "components/Common/ToastDialog";
import * as Yup from "yup"
import Breadcrumbs from "components/Common/BreadcrumbTitle"
import { EditorState } from 'draft-js'
import CommonDialog from "components/Common/CommonDialog"

import {
  addTemplate,
  editTemplate,
  getEmailTemplate
} from "../../helpers/UAM/emailTemplate.helper";
import { SystemConfigurationContext } from "context/systemConfigContext"
// import { useToast } from "ToastStore"

const AddEmailTemplate = props => {
  const navigate = useNavigate()
  const editorRef = useRef(null);
  const { inputMax } = useContext(SystemConfigurationContext)
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const [toastInfo, setToastInfo] = useState({ showToast: false })

  const location = useLocation()
  const pathnameSegments = location.pathname.split("/")
  const lastSegment = pathnameSegments[pathnameSegments.length - 1]

  let formattedLastSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).toLowerCase();

  document.title = `${formattedLastSegment} Template | DMS`

  const urlParams = new URLSearchParams(window.location.search)
  const encodedId = urlParams.get("id")
  const decodedId = atob(encodedId)

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [templateList, setTemplateList] = useState({})
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorError, setEditorError] = useState('');
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(true);

  // const { handleToastData } = useToast();

  useEffect(() => {
    if (lastSegment == "edit" || lastSegment == "view") {
      getEmailTemplate({ templateId: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            setTemplateList(responseFromAPI.data)
            const initialContent = responseFromAPI.data.emailBody;
            // const blocksFromHTML = convertFromHTML(initialContent);
            // const initialEditorState = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHTML));
            setEditorState(initialContent);
          }
        })
        .catch(error => { })
    }
    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }
  }, [])

  const handleEditorChange = () => {
    setEditorError('');
  };


  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      emailType: (templateList.emailType) || "",
      subject: (templateList.subject) || "",
      emailBody: (templateList.emailBody) || "",
    },
    validationSchema: Yup.object({
      emailType: Yup.string().required("Please Enter Email Type"),
      subject: Yup.string().required("Please Enter Email Subject"),
      // emailBody:  Yup.object().required("Ple")
    }),
    onSubmit: values => {

      const message = lastSegment == 'edit' ? 'Are you sure want to update template?' : 'Do you want to save entry?'
      setShowCommonDialog({ isShow: true, message: message })


    },
  })

  const navigateBack = () => {
    const encryptedtemplate = btoa("email");
    navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`)
  }

  const submiTemplates = () => {
    const { values } = validation
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
    if (!editorRef.current.getContent()) {
      setEditorError('Email Body is required.');
      return;
    }
    if (lastSegment == "edit") {
      const updateTemplate = {
        templateId: decodedId,
        emailType: values.emailType,
        subject: values.subject,
        emailBody: editorRef.current.getContent()
      }
      // update permission
      editTemplate(updateTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("email");
            setToastInfo({
              message: responseFromAPI.message,
              showToast: true,
              role: 'success',
            });
            setTimeout(() => {
              navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`);
            }, 1000);
          } else {
            setToastInfo({
              message: responseFromAPI.message,
              showToast: true,
              role: 'error',
            });
          }
        })
        .catch(error => { })
      validation.resetForm()
    } else {
      const newTemplate = {
        emailType: values.emailType,
        subject: values.subject,
        emailBody: editorRef.current.getContent()
      }

      addTemplate(newTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("email");
            setToastInfo({
              message: responseFromAPI.message,
              showToast: true,
              role: 'success',
            });
            setTimeout(() => {
              navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`);
            }, 1000);
          } else {
            setToastInfo({
              message: responseFromAPI.message,
              showToast: true,
              role: 'error',
            });
          }
        })
        .catch(error => { })
      validation.resetForm()
    }
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      submiTemplates()

    } else {

      setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={`${lastSegment.toUpperCase()} TEMPLATE`}
          />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  {showEditTemplate && <form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Type
                        </Label>
                        <Input
                          maxLength={inputMax}
                          type="text"
                          className="form-control"
                          name="emailType"
                          id="horizontal-email-Input"
                          placeholder="Enter Email Type"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailType || ""}
                          invalid={
                            validation.touched.emailType &&
                              validation.errors.emailType
                              ? true
                              : false
                          }
                        />
                        {validation.touched.emailType &&
                          validation.errors.emailType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.emailType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Subject
                        </Label>
                        <Input
                          maxLength={inputMax}
                          type="text"
                          className="form-control"
                          name="subject"
                          id="horizontal-email-Input"
                          placeholder="Enter Email Subject "
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.subject || ""}
                          invalid={
                            validation.touched.subject &&
                              validation.errors.subject
                              ? true
                              : false
                          }
                        />
                        {validation.touched.subject &&
                          validation.errors.subject ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subject}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Email Body
                        </Label>
                        <Editor
                          apiKey="q6dwhxw5tix1pp673y21owqpnaebbehtf393yirrsolans1b"
                          onInit={(evt, editor) => (editorRef.current = editor)}
                          initialValue={editorState}
                          init={{
                            selector: "textarea",
                            height: 500,
                            menubar: true,
                            branding: false,
                            plugins: [
                              "advlist",
                              "autolink",
                              "lists",
                              "link",
                              "image",
                              "charmap",
                              "preview",
                              "anchor",
                              "searchreplace",
                              "visualblocks",
                              "code",
                              "fullscreen",
                              "insertdatetime",
                              "media",
                              "table",
                              "code",
                              "help",
                              "wordcount",
                              'noneditable',
                            ],
                            noneditable_noneditable_class: "mceNonEditable",
                            toolbar:
                              "insertfile undo redo | blocks | " +
                              "bold italic forecolor | alignleft aligncenter " +
                              "alignright alignjustify | bullist numlist outdent indent | " +
                              "removeformat | help | code | noneditable",
                          }}
                          onEditorChange={handleEditorChange}

                        />
                        {editorError && (<div className="error">{editorError}</div>)}

                      </Col>

                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end" style={{ margin: "20px 0% 0px 0px" }}>
                          <button
                            type="submit"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              navigateBack();
                            }
                            }
                          >
                            Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                            style={{ marginLeft: "7px" }}
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </form>}
                  {showViewTemplate && <div>
                    <Row className="mb-4">
                      <Col sm={6}>
                        <Label
                          className="col-sm-3 col-form-label label label-styling"
                        >
                          Type
                        </Label>
                        <p>{templateList.emailType || "-"}</p>
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label label label-styling"
                        >
                          Subject
                        </Label>
                        <p>{templateList.subject || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={12}>
                        <Label
                          className="col-sm-6 col-form-label label label-styling"
                        >
                          Email Body
                        </Label>

                        <Editor
                          apiKey="q6dwhxw5tix1pp673y21owqpnaebbehtf393yirrsolans1b"
                          onInit={(evt, editor) => (editorRef.current = editor)}
                          initialValue={editorState}
                          init={{
                            selector: "textarea",
                            height: 500,
                            menubar: true,
                            branding: false,
                            readonly: 1,
                            plugins: [
                              "advlist",
                              "autolink",
                              "lists",
                              "link",
                              "image",
                              "charmap",
                              "preview",
                              "anchor",
                              "searchreplace",
                              "visualblocks",
                              "code",
                              "fullscreen",
                              "insertdatetime",
                              "media",
                              "table",
                              "code",
                              "help",
                              "wordcount",
                              'noneditable',
                            ],
                            noneditable_noneditable_class: "mceNonEditable",
                            toolbar:
                              "insertfile undo redo | blocks | " +
                              "bold italic forecolor | alignleft aligncenter " +
                              "alignright alignjustify | bullist numlist outdent indent | " +
                              "removeformat | help | code | noneditable",
                          }}
                          onEditorChange={handleEditorChange}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="text-end" >
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              navigateBack()
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

AddEmailTemplate.propTypes = {
  history: PropTypes.object,
}

export default AddEmailTemplate
